import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-up",
  "use": "icon-arrow-up-usage",
  "viewBox": "0 82.224 444.82 280.371",
  "content": "<symbol viewBox=\"0 82.224 444.82 280.371\" id=\"icon-arrow-up\">\r\n<g>\r\n\t<path d=\"M433.968,278.658L248.387,92.79c-7.419-7.044-16.08-10.566-25.977-10.566c-10.088,0-18.652,3.521-25.697,10.566\r\n\t\tL10.848,278.658C3.615,285.886,0,294.548,0,304.636c0,10.281,3.619,18.844,10.848,25.693l21.411,21.414\r\n\t\tc6.854,7.229,15.42,10.852,25.697,10.852c10.278,0,18.842-3.621,25.697-10.852L222.41,213.271L361.167,351.74\r\n\t\tc6.848,7.229,15.414,10.852,25.701,10.852c10.082,0,18.746-3.623,25.975-10.852l21.408-21.412\r\n\t\tc7.043-7.043,10.568-15.607,10.568-25.693C444.82,294.544,441.205,285.884,433.968,278.658z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./app/general/svg/arrow-up.svg
// module id = Omm2
// module chunks = 0